export default {
  getMenuOption: state => state.menuOption,
  getSubMenuOption: state => state.subMenuOption,
  getNotificationBellAmount: state => state.notificationBellAmount,
  getLastTotalNotificationCount: state => state.lastTotalNotificationCount,
  getCurrentTotalNotificationCount: state =>
    state.currentTotalNotificationCount,
  getUpdatedRoute: state => state.updatedRoute
}
